import React, { useState, useEffect } from 'react';
import { RootState } from '../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import { translations } from '../utils/translations';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Card, Breadcrumb, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import './category.css';
interface Category {
    id: number;
    name: string;
    description: string;
}

export default function CategoryComponent() {
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<string | null>(null);
    const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const [editName, setEditName] = useState<string>('');
    const [editDescription, setEditDescription] = useState<string>('');
    const [newCategoryName, setNewCategoryName] = useState<string>('');
    const [newCategoryDescription, setNewCategoryDescription] = useState<string>('');
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>(''); // State for search term

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);
    const language = useSelector((state: RootState) => state.language.language);
    const t = translations[language as keyof typeof translations];

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    const fetchData = async () => {
        try {
            const token = getCookie('token');
            if (!token) {
                dispatch(setAuth(false));
                return;
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const userResponse = await axios.get('https://api.sominnovations.xyz/users/user', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setUserRole(userResponse.data.user.role);
            dispatch(setAuth(true));
        } catch (e) {
            dispatch(setAuth(false));
        }
    };

    const fetchCategories = async (page: number) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.sominnovations.xyz/Branches/categories/?page=${page}&search=${searchTerm}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setCategories(response.data.results);
            setTotalPages(Math.ceil(response.data.count / 20)); // Assuming 20 items per page
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        if (auth) {
            fetchCategories(currentPage);
        }
    }, [auth, currentPage, searchTerm]); // Add searchTerm to dependencies

    const handleEdit = (category: Category) => {
        setSelectedCategory(category);
        setEditName(category.name);
        setEditDescription(category.description);
        setShowEditModal(true);
    };

    const handleSaveEdit = async () => {
        if (selectedCategory) {
            try {
                await axios.put(`https://api.sominnovations.xyz/Branches/categories/${selectedCategory.id}/`, {
                    name: editName,
                    description: editDescription,
                });
                setCategories(categories.map(cat =>
                    cat.id === selectedCategory.id ? { ...cat, name: editName, description: editDescription } : cat
                ));
                setShowEditModal(false);
            } catch (error) {
                console.error('Error updating category:', error);
            }
        }
    };

    const handleCreateCategory = async () => {
        try {
            const response = await axios.post('https://api.sominnovations.xyz/Branches/categories/', {
                name: newCategoryName,
                description: newCategoryDescription,
            });
            setCategories([...categories, response.data]);
            setShowCreateModal(false);
            setNewCategoryName('');
            setNewCategoryDescription('');
        } catch (error) {
            console.error('Error creating category:', error);
        }
    };

    const handleView = (id: number) => {
        console.log('View category with ID:', id);
    };

    const handleDelete = async (id: number) => {
        if (window.confirm("Are you sure you want to delete category?")) {
            try {
                await axios.delete(`https://api.sominnovations.xyz/Branches/categories/${id}/`);
                setCategories(categories.filter(category => category.id !== id));
                console.log('Deleted category with ID:', id);
            } catch (error) {
                console.error('Error deleting category:', error);
            }
        }
    };

    return (
        <div className="container mt-1 categories-container" style={{ padding: "10px" }}>
            <Card className="mb-4">
                <Card.Header style={{ backgroundColor: '#5271ff', color: '#fff' }}>
                    <div className="d-flex justify-content-between align-items-center" style={{ color: "white" }}>
                        <h4>{t.category}</h4>
                        <Breadcrumb >
                            <Breadcrumb.Item href="dashboard"> <p style={{ color: "white" }}>{t.dashboard}</p> </Breadcrumb.Item>
                            <Breadcrumb.Item active >{t.category}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Button variant="warning" onClick={() => setShowCreateModal(true)}>
                        + {t.createCategory}
                    </Button>
                </Card.Body>
            </Card>

            <div className="mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Categories..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
                />
            </div>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <table className="table table-striped table-responsive table-sm" style={{ fontSize: '14px', margin: 'auto' }}>
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>{t.categoryName}</th>
                                <th>{t.description}</th>
                                <th>{t.actions}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((category, index) => (
                                <tr key={category.id}>
                                    <td>{index + 1 + (currentPage - 1) * 20}</td>
                                    <td>{category.name}</td>
                                    <td>{category.description}</td>
                                    <td>
                                        <button
                                            className="btn btn-warning btn-sm me-2"
                                            onClick={() => handleEdit(category)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        {userRole !== 'accountant' && (
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDelete(category.id)}
                                            >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <Pagination>
                        <Pagination.Prev
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </>
            )}

            {/* Create Category Modal */}
            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="newName">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="newName"
                            value={newCategoryName}
                            onChange={(e) => setNewCategoryName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="newDescription">Description</label>
                        <textarea
                            className="form-control"
                            id="newDescription"
                            rows={3}
                            value={newCategoryDescription}
                            onChange={(e) => setNewCategoryDescription(e.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>Close</Button>
                    <Button variant="primary" onClick={handleCreateCategory}>Create</Button>
                </Modal.Footer>
            </Modal>

            {/* Edit Category Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="editName">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="editName"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="editDescription">Description</label>
                        <textarea
                            className="form-control"
                            id="editDescription"
                            rows={3}
                            value={editDescription}
                            onChange={(e) => setEditDescription(e.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>Close</Button>
                    <Button variant="primary" onClick={handleSaveEdit}>Save Changes</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
